export function getAccessToken () {
  let token = localStorage.getItem('token')
  if(!token){
    throw new Error('Token object is empty');
  }
  const accessToken = token.replace(/^"(.*)"$/, '$1');
  return accessToken;
}
